module.exports = __webpack_public_path__ + "img/3.9bc351a9.jpg";